module.exports = __webpack_public_path__ + "img/image1.66c6d025.jpg";